<template>
    <form id="login-form" v-on:keyup.enter="onSubmit">
        <input type="hidden" name="_csrf"
               value="0sg7OhAxLL4HUMSN8uKEjcg2GqABzcjnUrOykkHgmx-UkUNrZntK9F9kifW4jubMoVJRk3OJvp5i3sWqAoj-eQ==">
        <div style="padding-bottom: 35px;" class="col-md-12">
            <div class="col-md-offset-1 col-md-10">
                    <div class="form-group field-client-name required">
                        <input v-on:input="onUsernameChange"
                               v-model="username"
                               type="text"
                               class="input__field input__field--hoshi user-icon-input"
                               placeholder="Username"
                               style="border-bottom:1px solid lightgray;"
                                >

                    </div>
                    <div class="form-group field-client-name required">
                       <input v-on:input="onPasswordChange"
                              v-model="password"
                              type="password"
                              class="input__field input__field--hoshi user-icon-input"
                              placeholder="Password"
                              style="border-bottom:1px solid lightgray;"
                       >
                    </div>
            </div>
            <div class="form-group field-client-card">
                <div class="help-block"></div>
            </div>
            <div style="margin-top: 20px;" class="col-md-12 col-xs-12 col-sm-12">
                <button v-on:click="onSubmit" type="button" class="btn btn-primary btn-sm" v-bind:style="{ background: buttonBackground}">SEND</button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: 'login-form',
        data () {
            return {
                username: '',
                password: '',
                buttonBackground: ''
            }
        },
        mounted() {
            this.buttonBackground = this.$store.getters.getButtonColor;
        },
        methods: {
            onUsernameChange: function() {
                console.log(this.username);
            },
            onPasswordChange: function() {
                console.log(this.password);
            },
            onSubmit: function() {

                let loader = this.$loading.show({
                    // Optional parameters
                    fullPage: true,
                    onCancel: this.onCancel
                });

                const { username, password } = this;
                this.$store.dispatch('AUTH_REQUEST', { username, password }).then(() => {
                    loader.hide();
                    this.$router.push('/')
                }).catch((err) => {
                    loader.hide();
                    if (err.response.status === 403) {
                        this.$swal({
                            title: 'Error',
                            text: 'Invalid username or password',
                            icon: 'error',
                            confirmButtonColor: '#f93e56',
                            confirmButtonText: 'Close'
                        });
                    } else {
                        this.$swal({
                            title: 'Error',
                            text: 'Error while connecting to server',
                            icon: 'error',
                            confirmButtonColor: '#f93e56',
                            confirmButtonText: 'Close'
                        });
                    }
                })
            }
        },
    }
</script>
